var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"card"},_vm.$listeners),[_c('img',{staticClass:"card__image",attrs:{"src":require("@/assets/product/pattern.png")}}),_c('p',{staticClass:"card__title"},[_vm._v(_vm._s(_vm.product.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }